import { createContext } from 'react';

export type TTypeOfModalWindow = null | 'cropper';
export type TTypeOfErrorModalWindow =
	| null
	| 'fileSizeExceeded'
	| 'gifFileSizeExceeded'
	| 'videoFileSizeExceeded'
	| 'fileUploadError'
	| 'invalidFileFormat'
	| 'invalidGifFormat'
	| 'invalidVideoFormat';
export type TImageOrientation = 'horizontal' | 'vertical';
export interface ILoadFromFilePathOptions {
	filePath: string | null;
	preSignedUrl: string | null;
	entityID: string;
}

export interface IMaxFileSizeMB {
	img: number;
	gif?: number;
	video?: number;
}

export interface IPendingMedia {
	file: File | Blob | null;
	src: string | null;
}

const emptyPendingMedia: IPendingMedia = { file: null, src: null };

export interface IFormImageUploaderNewState {
	imageOrientation: TImageOrientation;
	isLoading: boolean;
	isUploadingVideo: boolean;
	croppedSizeSrc: string | null;
	committedVideoSrc: string | null;
	pendingImage: IPendingMedia;
	pendingGif: IPendingMedia;
	pendingVideo: IPendingMedia;
	typeOfModalWindow: TTypeOfModalWindow;
	typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	loadingImageError: boolean;
}

export const formImageUploaderNewInitialState: IFormImageUploaderNewState = {
	imageOrientation: 'horizontal',
	isLoading: false,
	isUploadingVideo: false,
	croppedSizeSrc: null,
	committedVideoSrc: null,
	pendingImage: emptyPendingMedia,
	pendingGif: emptyPendingMedia,
	pendingVideo: emptyPendingMedia,
	typeOfModalWindow: null,
	typeOfErrorModalWindow: null,
	loadingImageError: false,
};

export interface IFormImageUploaderNewContext extends IFormImageUploaderNewState {
	setImageOrientation(value: TImageOrientation): void;
	setLoading(value: boolean): void;
	setCroppedSizeSrc(src: string | null): void;
	setCommittedVideoSrc(src: string | null): void;
	setPendingImage(value: IPendingMedia): void;
	setPendingGif(value: IPendingMedia): void;
	setPendingVideo(value: IPendingMedia): void;
	uploadImage(value: Blob): Promise<void>;
	uploadVideo(value: File): Promise<void>;
	keepExistingFile(): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeTypeOfErrorModalWindow(value: TTypeOfErrorModalWindow): void;
	setLoadingImageError(value: boolean): void;
}

export const FormImageUploaderNewContext = createContext<IFormImageUploaderNewContext>({
	setImageOrientation: () => undefined,
	setLoading: () => undefined,
	setCroppedSizeSrc: () => undefined,
	setCommittedVideoSrc: () => undefined,
	setPendingImage: () => undefined,
	setPendingGif: () => undefined,
	setPendingVideo: () => undefined,
	uploadImage: async () => undefined,
	uploadVideo: async () => undefined,
	keepExistingFile: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeTypeOfErrorModalWindow: () => undefined,
	setLoadingImageError: () => undefined,
	...formImageUploaderNewInitialState,
});
